import { render, staticRenderFns } from "./BudgetDivided.vue?vue&type=template&id=114062a6&"
import script from "./BudgetDivided.vue?vue&type=script&lang=js&"
export * from "./BudgetDivided.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports